import { render, staticRenderFns } from "./CardSliderComparison.vue?vue&type=template&id=2446b79c&scoped=true&"
import script from "./CardSliderComparison.vue?vue&type=script&lang=js&"
export * from "./CardSliderComparison.vue?vue&type=script&lang=js&"
import style0 from "./CardSliderComparison.vue?vue&type=style&index=0&id=2446b79c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2446b79c",
  null
  
)

export default component.exports